import React from "react";
import styles from "./WhoWeAre.module.scss";

function WhoWeAre({ content }) {
  // STATES
  // STORE STATES
  // HOOKS
  // METHODS
  // EFFECTS
  // RENDER
  return (
    <section className={styles.whoWeAre}>
      <div className={styles.whoWeAreContent}>
        <h2 className={styles.whoWeAreTitle}>{content?.title}</h2>
        <p className={styles.whoWeAreBody}>{content?.body}</p>
      </div>
      <div className={styles.whoWeAreHero}>
        <img className={styles.whoWeAreImage} src={content?.image} alt="hero" />
        <img
          className={styles.whoWeAreImage}
          src={content?.image2}
          alt="hero"
        />
        <div className={styles.whoWeAreSecondaryContent}>
          <h3 className={styles.whoWeAreSecondaryTitle}>
            {content?.story_title}
          </h3>
          <p className={styles.whoWeAreSecondaryBody}>{content?.story_body}</p>
        </div>
      </div>
    </section>
  );
}
export default WhoWeAre;
